
import { io } from 'socket.io-client';

export const socketIo = (host, port) => {
    const auth_token = "TEST_TOKEN";
    return io(`wss://${host}:${port}`, {
        // auth: {
        //     token: auth_token,
        // },
    });
}